// Recipients for "Email this report": one per line or comma-separated,
// trimmed, lower-cased and de-duplicated. The server validates again.
export const MAX_RECIPIENTS = 20;
export const MAX_SUBJECT = 150;
export const MAX_MESSAGE = 2000;

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const parseRecipients = (raw) => {
  const seen = new Set();
  const valid = [];
  const invalid = [];
  raw
    .split(/[\n,;]+/)
    .map((entry) => entry.trim().toLowerCase())
    .filter(Boolean)
    .forEach((entry) => {
      if (seen.has(entry)) return;
      seen.add(entry);
      (EMAIL_RE.test(entry) ? valid : invalid).push(entry);
    });
  return { valid, invalid };
};

export const emailError = (error) => {
  const status = error?.response?.status;
  const serverMessage = error?.response?.data?.error;
  if (status === 404 && !serverMessage) {
    return "Emailing reports isn't available on the server yet.";
  }
  if (status === 413) return 'The PDF is too large to email.';
  if (status === 415) return "The report file wasn't a valid PDF. Try again.";
  // The server says when the next send is possible / which permission is needed.
  if (status === 429) {
    return (
      serverMessage || "You've sent several reports recently. Try again later."
    );
  }
  if (status === 403) {
    return (
      serverMessage ||
      'You need the SendImpactReport permission to email reports.'
    );
  }
  // Some emails may already be queued: never resend blindly.
  if (status === 502) {
    return `${
      serverMessage || 'The email service had a problem part-way through.'
    } Some partners may already have it, so check before sending again.`;
  }
  return serverMessage || "We couldn't send the report. Please try again.";
};
